<template>
  <div
    class="rounded shadow-sm bg-white px-3 py-2 my-5 md:my-0 md:px-8 md:py-5 max-w-screen-lg mx-auto"
  >
    <div class="flex flex-col md:px-20">
      <div class="flex flex-col py-3">
        <h5 class="text-2xl">Document name</h5>
        <SingleLineInput
          :value="name"
          @input="name = $event.target.value"
          placeholder="Rental disclosures 2023"
        ></SingleLineInput>
        <p class="text-sm text-brand-gray">
          Give it a helpful name (ex. applicant disclosures, 2023 lease, payment authorization, etc)
        </p>
      </div>
      <!-- <div class="flex flex-col py-3">
        <h5 class="text-2xl">Document description</h5>
        <SingleLineInput
          :value="description"
          @input="description = $event.target.value"
          placeholder="New document description here"
        ></SingleLineInput>
        <p class="text-sm text-brand-gray">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </p>
      </div> -->

      <div class="flex flex-col py-3">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center">
            <h5 class="block text-2xl py-1">Uploaded files</h5>
          </div>
          <div class="flex items-center" v-if="files.length">
            <p class="text-brand-red cursor-pointer" @click="removeAll">Delete all</p>
          </div>
        </div>
      </div>

      <template v-if="files.length">
        <Draggable class="dragArea list-group w-full" :list="files" :animation="200" :sort="true">
          <div
            v-for="(file, idx) in files"
            :key="idx"
            class="flex items-center justify-between w-full bg-brand-light-gray py-5 px-5 rounded-xl mb-2"
          >
            <div class="flex items-center">
              <img src="@/assets/icons/double-dot.svg" class="w-4 h-4 mr-2 cursor-pointer" />
              <p class="text-brand-gray truncate">{{ file.name }}</p>
            </div>
            <div class="flex items-center" @click="removeFile(idx)">
              <TrashIcon class="text-brand-red w-6 h-6 mr-2 cursor-pointer" />
            </div>
          </div>
        </Draggable>
      </template>

      <div class="flex items-center py-5">
        <div
          class="flex w-full bg-brand-light-gray md:h-72 py-5 px-5 rounded-xl"
          @dragover="dragover"
          @dragleave="dragleave"
          @drop="dropUpload"
        >
          <div
            class="flex items-center justify-center w-full h-full border-4 border-brand-gray border-dashed rounded-xl"
          >
            <div class="flex flex-col items-center justify-center">
              <h4>
                Drag and drop files here or
                <span @click.stop="$refs.fileInput.click()" class="text-brand-green cursor-pointer"
                  >click to upload</span
                >
              </h4>
              <p class="text-brand-gray text-sm">
                Supported: PDF, PNG, JPG, JPEG, Maximum upload file size: 10 MB
              </p>
            </div>
          </div>
          <input
            ref="fileInput"
            type="file"
            accept="image/*,application/pdf"
            data-max-size="10000"
            hidden
            @change="clickUpload"
          />
        </div>
      </div>

      <div class="flex flex-col justify-between py-5">
        <div class="w-full md:w-1/3 mx-auto py-1">
          <div class="flex items-center justify-center py-1" v-if="errorMessage">
            <p class="text-brand-red">{{ errorMessage }}</p>
          </div>
          <PrimaryButton @click="next">Next</PrimaryButton>

          <p @click="backToDashboard" class="text-brand-green text-center my-8 cursor-pointer">
            Back
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { TrashIcon } from "@heroicons/vue/outline"
import { DOCUMENT_TEMPLATE_SET_TEMP } from "@/store/types"

import { VueDraggableNext } from "vue-draggable-next"

import randomize from "randomatic"

export default {
  components: {
    TrashIcon,

    Draggable: VueDraggableNext
  },
  computed: {
    ...mapGetters([
      "getCurrentUser",
      "getCurrentNewApplicationTemplate",
      "isApplicationTemplateLoading"
    ])
  },
  async mounted() {},
  data() {
    return {
      name: "",
      description: "",
      isDragging: false,
      files: [],
      errorMessage: ""
    }
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "dashboard_documents" })
    },
    removeFile(idx) {
      this.files.splice(idx, 1)
    },
    removeAll() {
      this.files = []
    },
    uploadFile(files) {
      if (files.length) {
        const fileSize = files[0].size / 1024 / 1024

        if (fileSize > 10) {
          this.errorMessage = "File size is over 10mb."
          setTimeout(() => {
            this.errorMessage = ""
          }, 3000)
          return
        }
      }

      files.forEach((file) => {
        const filename = file.name
          .split(".")[0]
          .replaceAll(" ", "_")
          .replace(/[^A-Z0-9_-]+/gi, "")
        const fileExtension = file.name.split(".").pop()
        const myNewFile = new File(
          [file],
          `${filename.slice(0, 25)}_${randomize("a0", 6)}.${fileExtension}`,
          {
            type: file.type
          }
        )
        this.files.push(myNewFile)
      })
    },
    dragover(e) {
      e.preventDefault()
      console.log("dragover")
      this.isDragging = true
    },
    dragleave() {
      console.log("dragleave")
      this.isDragging = false
    },
    clickUpload(e) {
      const files = [...e.target.files]
      this.uploadFile(files)
    },
    dropUpload(e) {
      e.preventDefault()
      console.log("drop")

      const files = [...e.dataTransfer.files]

      this.uploadFile(files)
      this.isDragging = false
    },
    next() {
      if (!this.files.length) {
        this.errorMessage = "Please add a document first."
        setTimeout(() => {
          this.errorMessage = ""
        }, 3000)
        return
      }
      const { name, description, files } = this

      this.$store.commit(DOCUMENT_TEMPLATE_SET_TEMP, { name, description, files })
      this.$router.push({ name: "dashboard_new_document_fields" })
    }
  }
}
</script>
